import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  rowButtonsWidgetProps: Object.assign({
    direction: 'row',
    leftCta: {
      title: 'Email Bill',
      buttonType: 'secondary'
    },
    rightCta: {
      title: 'Primary',
      buttonType: 'primary'
    },
    onLeftCtaPress: {
      id: 'left-cta'
    },
    onRightCtaPress: {
      id: 'right-cta'
    }
  }, getTestId('ButtonWidgetContainer')),
  detailsTaskCardList: [{
    infoList: [{
      tagName: 'Platinum'
    }, {
      tagName: 'High'
    }, {
      tagName: 'Black'
    }, {
      tagName: 'FTTH'
    }],
    actionIcon: {
      iconName: 'MoreIcon',
      onActionPress: {
        id: 'MoreIcon'
      }
    },
    leftIconName: 'ClockIcon',
    leftText: '08:30 - 09:30 am',
    leftTextOnPressMetaData: {
      id: 'left-text'
    },
    isLeftTextClickable: true,
    rightIconName: 'CalendarIcon',
    rightText: '23 October',
    rightTextOnPressMetaData: {
      id: 'right-text'
    },
    isRightTextClickable: true,
    taskCardtitleText: 'Home visit | Broadband | Acquisition',
    taskCardtitleTextOnPressMetaData: {
      id: 'task-card-title-text'
    },
    isClickableTitleText: true,
    subtitleText: 'Product name here',
    subtitleTextOnPressMetaData: {
      id: 'subtitle-text'
    },
    isSubtitleTextClickable: true,
    descriptionText: 'Description text comes here',
    descriptionTextOnPressMetaData: {
      id: 'description-text'
    },
    isDescriptionTextClickable: true,
    detailsData: [{
      key: 'Bill Cycle',
      value: '24th Aug - 23rd Sept',
      onPressValueMetaData: {
        id: 'hshshsh'
      }
    }, {
      key: 'Due Date',
      value: '12th Dec 2023'
    }, {
      key: 'Rental',
      value: '6 months'
    }, {
      key: 'Renewal Date',
      value: '12th Dec 2023'
    }],
    numberOfColumns: 3,
    calloutWidgetProps: {
      title: '',
      description: 'after 17 oct you will be charged ₹100 as late fee, payable ₹1,278.00 ',
      iconName: 'AlertMediumButtonIcon',
      state: 'warning'
    },
    profileFooter: {
      profileName: 'deepak mishra',
      profileClick: {
        id: 'jshjsjsj'
      },
      width: 56,
      height: 56,
      profileImageIcon: 'ProfileIcon',
      status: 'default'
    }
  }],
  profileFooter: {
    profileName: 'deepak mishra',
    profileClick: {
      id: 'hshshsh'
    },
    width: 56,
    height: 56,
    profileImageIcon: 'ProfileIcon',
    status: 'default'
  }
}, getTestId('TaskCardWidgetContainer'));